import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BedStatesService } from '../../../core/services/bed-states.service';

@Component({
  selector: 'app-bed-states-session',
  imports: [TranslateModule],
  template: `
    @if (store.canView && store.error()) {
      <aside class="bed-states-error" role="alert">
        <span>{{store.error() | translate}}</span>
        <button type="button" (click)="store.refresh()">{{'BED_STATES.RETRY' | translate}}</button>
      </aside>
    }
  `,
  styles: [`
    :host { display: contents; }
    .bed-states-error { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 14px; padding: 10px 14px; margin-bottom: 16px; border: 1px solid #dce7ee; border-radius: 12px; color: #475569; background: #f8fafc; font-size: 12px; }
    button { color: #1967d2; border: 1px solid #cbd5e1; border-radius: 6px; background: white; padding: 5px 10px; cursor: pointer; }
  `]
})
export class BedStatesSessionComponent implements OnInit, OnDestroy {
  readonly store = inject(BedStatesService);
  private release?: () => void;
  ngOnInit(): void { this.release = this.store.acquire(); }
  ngOnDestroy(): void { this.release?.(); }
}
